<template>
  <!-- 基础数据配置 -->
  <div class="contentBox">
    <div style="height: 60px; width: 100%"></div>
    <div class="topBtns">
      <el-button style="margin-top: 10px" class="glo_bgcMainColor" @click="submit">保存</el-button>
    </div>
    <!-- 营业执照 -->
    <div class="infoDiv">
      <el-form ref="baseInForm" label-width="140px" class="glo_formBox">
        <el-form-item :label="item.key_show" v-for="(item, index) in lists" :key="index">
          <el-input v-model="item.val" placeholder="请输入" clearable />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import uploadimgs from "@/components/upLoadImgs.vue";
export default {
  inject: ["reload"],
  components: {
    uploadimgs,
  },
  data() {
    return {
      lists: [],
    };
  },
  watch: {},
  created() {},
  mounted() {},
  activated() {
    this.GetData();
  },
  destroyed() {},
  methods: {
    async GetData() {
      this.$API
        .runPageReportDetails({
          conditionReqs: [],
          number: "base_data_info",
        })
        .then((res) => {
          if (res.data.status === "success") {
            this.lists = res.data.result.datas || [];
          } else {
            this_.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
    },
    submit() {
      let datas = this.lists.map((n) => {
        return {
          key: n.key,
          type: n.type,
          val: n.val,
        };
      });

      this.$API
        .saveBaseDataInfo({
          datas,
        })
        .then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
          }
        });
    },
  },
};
</script>
<style scoped lang="less">
// 查询条件边框线
@borderColor: #cccccc;

.topBtns {
  width: calc(100% - 240px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin-right: 30px;
  height: 50px;
}
.contentBox {
  padding-bottom: 50px;
}

.infoDiv {
  margin-bottom: 20px;

  .formbox {
    padding: 0 30px;
  }
}
</style>
